import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { Setting } from '@element-plus/icons-vue';
import { useRouter } from "vue-router";
import { onMounted, reactive, ref, toRefs } from 'vue';
import apis from "@/api";
export default {
  name: "Index",
  components: {
    Setting
  },
  setup(props, context) {
    const treeRef = ref(null);
    const roleTreeRef = ref(null);
    const router = useRouter();
    const defaultProps = {
      children: "children",
      label: "name",
      disabled: "disabled"
    };
    const roleTreeProps = {
      children: 'children',
      label: 'roleName'
    };
    const data = reactive({
      defaultCheckedRoleKeys: [],
      roleTrees: [],
      allOptList: [],
      checkedOptList: [],
      permissionTree: [],
      checkedPermList: [],
      roleList: [],
      ckeckedRoleId: '',
      checkedPermTreeId: ''
    });
    const showRoleMng = () => {
      router.push('/setting-center/auth-mng/role');
    };
    const showPermissionMng = () => {
      router.push('/setting-center/auth-mng/permission');
    };
    const roleListAll = () => {
      apis.roleTree().then(res => {
        if (res.success) {
          console.log(res.data);
          data.roleTrees = res.data;
          data.ckeckedRoleId = res.data[0].roleId;
          data.defaultCheckedRoleKeys = ["2c078b3dffe547ae9d43f96d63c5b08b"];
          // data.defaultCheckedRoleKeys = [data.ckeckedRoleId]
          console.log(data.defaultCheckedRoleKeys);
          checkRole(res.data[0]);
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const checkRole = (obj, node, el) => {
      const {
        roleId
      } = obj;
      console.log(roleId);
      data.ckeckedRoleId = roleId;
      apis.queryRolePermission({
        roleId
      }).then(res => {
        if (res.success) {
          const idChecked = [];
          if (res.data.length > 0) {
            res.data.forEach(p => {
              idChecked.push(p.id);
            });
          }
          data.checkedPermList = idChecked;
          treeRef.value.setCheckedKeys(idChecked, false);
        } else {
          ElMessage.error(res.msg);
        }
      });
      getOptOfRole();
    };
    const saveRolePerm = permissionId => {
      apis.saveRolePerm({
        roleId: data.ckeckedRoleId,
        permissionId: permissionId
      }).then(res => {
        if (res.success) {
          ElMessage.success('角色权限修改成功');
          checkRole({
            roleId: data.ckeckedRoleId
          });
        } else {
          ElMessage.error('角色权限修改失败');
        }
      });
    };
    const removeRolePerm = permissionId => {
      apis.removeRolePerm({
        roleId: data.ckeckedRoleId,
        permissionId: permissionId
      }).then(res => {
        if (res.success) {
          ElMessage.success('角色权限修改成功');
          checkRole({
            roleId: data.ckeckedRoleId
          });
        } else {
          ElMessage.error('角色权限修改失败');
        }
      });
    };
    const handleCheck = (node, check, child) => {
      if (check) {
        if (data.checkedPermList.indexOf(node.id) < 0) {
          saveRolePerm(node.id);
        }
      } else {
        if (data.checkedPermList.indexOf(node.id) > -1) {
          removeRolePerm(node.id);
        }
      }
    };
    const initPermTree = () => {
      apis.permissonPage({
        noMenuType: 2
      }).then(res => {
        if (res.success) {
          data.permissionTree = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const handleNodeClick = (obj, node, el) => {
      data.checkedPermTreeId = obj.id;
      getAllOptList();
      getCheckedOfRole();
    };
    const getOptOfRole = () => {
      getAllOptList();
      getCheckedOfRole();
    };
    const getAllOptList = () => {
      apis.permissionListByParentId({
        parentId: data.checkedPermTreeId,
        menuType: 2
      }).then(res => {
        if (res.success) {
          data.allOptList = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const getCheckedOfRole = () => {
      apis.permissionListByPidOfRole({
        roleId: data.ckeckedRoleId,
        parentId: data.checkedPermTreeId,
        menuType: 2
      }).then(res => {
        if (res.success) {
          const nameChecked = [];
          if (res.data.length > 0) {
            res.data.forEach(p => {
              nameChecked.push(p.name);
            });
          }
          data.checkedOptList = nameChecked;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const optCheckChange = (val, id) => {
      if (val) {
        saveRolePerm(id);
      } else {
        removeRolePerm(id);
      }
    };
    onMounted(() => {
      roleListAll();
      initPermTree();
    });
    return {
      ...toRefs(data),
      treeRef,
      roleTreeRef,
      defaultProps,
      roleTreeProps,
      showPermissionMng,
      showRoleMng,
      checkRole,
      handleCheck,
      handleNodeClick,
      optCheckChange
    };
  }
};